import React, { useEffect } from 'react'
import './styles.scss'
import { getStaticImage } from 'utils/statics'
import DropdownCustom from 'components/common/Dropdown'
import Header from './Header'
import { useDispatch, useSelector } from 'react-redux'
import dashNotificationAct from 'redux/dashNotifications/actions'
import NotificationCard from './NotificationCard'
import ClickOutHandler from 'react-onclickout'
import { useHistory } from 'react-router'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { toastMessage } from 'utils/messages'
import { I18n } from 'react-redux-i18n'
import NotResult from 'components/common/NotResult'

const PATH = '/dashboard/conversations/'
const POOLS = ['users', 'assignations', 'lists', 'search', 'search']

const NotificationDash = () => {

  const dispatch = useDispatch()
  const history = useHistory()
  const dashNotifications  = useSelector((store)=> store.dashNotifications)

  const {
    notifications,
    loading,
    hasNotification,
    filters,
    failure,
    isOpen,
    getMore
  } = dashNotifications

  useEffect(() => {
    dispatch(dashNotificationAct.getHasNew())
  }, [])


  useEffect(() => {
    if(notifications.length > 0){
      dispatch(dashNotificationAct.verifyNotifications(notifications))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications])

  useEffect(() => {
    if(isOpen){
      dispatch(dashNotificationAct.getNotificationsDash())
    }else{
      if(notifications.length > 0) dispatch(dashNotificationAct.clearNotification())
    }

    const modalContent = document.querySelector('#dashNotification')
    if(isOpen && modalContent){
      modalContent.addEventListener('scroll', handleScroll)
    }else{
      if(modalContent) modalContent.removeEventListener('scroll', handleScroll)
    }
  }, [isOpen])

  function handleScroll(event) {
    const scrollTop = event.target.scrollTop
    const scrollHeight = event.target.scrollHeight
    const clientHeight = event.target.clientHeight
    if (scrollTop + clientHeight >= scrollHeight) {
      handleNextPage()
    }
  }

  const handleNextPage = () => {
    dispatch(dashNotificationAct.updatePage(true))
  }

  const markAsRead = async (idNotification, isRead)=>{
    const resp = await dispatch(dashNotificationAct.updateRead({
      notificationId: idNotification,
      isRead: isRead
    }))
    if(resp === 'error'){
      toastMessage(I18n.t('dash_notification_errro_flagging_notification'), 'error')
    }
  }

  const openConversation = (userConversation) => {
    const { pathname } = history.location
    const verify = verifyRoute(PATH, POOLS, pathname)
    if(verify){
      history.push(`${pathname}?user_id=${userConversation.userId}`)
    }else{
      history.push(`/dashboard/conversations/users?user_id=${userConversation.userId}`)
    }
  }

  const verifyRoute = (path, pools, pathName) =>{
    return pools.some(pool => {
      const newPath = path + pool
      return pathName === newPath
    })
  }

  const setOpen = (open) => {
    dispatch(dashNotificationAct.setIsOpen(open))
  }

  return (
    <ClickOutHandler onClickOut={() => {
      if(isOpen){
        setOpen(false)
      }
    }}>
      <div className={'container-notification'}>
        <button className='button-icon' onClick={()=> setOpen(!isOpen)} >
          {hasNotification &&
            <div className='point'/>
          }
          <img src={getStaticImage(`/icons/orange-brand/icon-${isOpen ? 'bell-selected' : 'bell'}.svg`)}  alt={`${isOpen ? 'BellSelected' : 'Bell'}`}/>
        </button>

        <DropdownCustom
          header={
            <Header
              setOpen={setOpen}
              markAsRead={markAsRead}
              dispatch={dispatch}
              dashNotificationAct={dashNotificationAct}
              filters={filters}
            />
          }
          isOpen={isOpen}
          id='dashNotification'
          className='container-dropdown'
        >
          <div className='list-wrapper' >
            {notifications.map((notification)=>(
              <NotificationCard
                key={notification._id}
                notification={notification}
                markAsRead={markAsRead}
                openConversation={openConversation}
              />
            ))}
            {loading && <div style={{ marginTop: '20px' }}>
              <Nixi1Spinner height='30' width='30' />
            </div>}
            
            {!getMore &&
              <NotResult message={I18n.t('dashboard_no-more-messages')} />
            }
            
            {(notifications.length === 0 && !loading) &&
              <NotResult />
            }

            {failure &&
              <NotResult message={I18n.t('message_error_data_list_distribution')} />
            }
          </div>
        </DropdownCustom>
      </div>
    </ClickOutHandler>
  )
}

export default NotificationDash
